import { getLocalStorage, setLocalStorage } from '@com/utils/storage.js'
import { format } from 'date-fns'

interface ShowValue {
  at: string
}

// 额度过期弹窗显示的key
// date `YYYYMMDD`
function createPlanExpireKey(id: number) {
  return `plan_expire_show_${id}`
}

export function isPlanExpireShowed(id: number): boolean {
  try {
    const today = format(new Date(), 'YYYYMMDD')

    const storage = getLocalStorage(createPlanExpireKey(id))

    if (storage) {
      const { at } = JSON.parse(storage) as ShowValue

      return at === today
    }

    return false
  } catch (e) {
    return false
  }
}

export function setPlanExpireShowed(id: number): void {
  const value: ShowValue = {
    at: format(new Date(), 'YYYYMMDD'),
  }

  setLocalStorage(createPlanExpireKey(id), JSON.stringify(value))
}
